/* eslint-disable max-len */
import moment from 'moment'
import React, { useContext} from "react";
import GlobalContext from "../../../../components/Context/GloablContext";


export default function ViewTerm({
    state,handleInput,editData,handleSubmit,submitSelected,Edit,setEdit
}) {
    const { isInactiveBranch } = useContext(GlobalContext);

    return (
        <div className="mainDataCntnrPageDiv scrollBlue_thick">
            <div className="display">
                <div className="xl:w-[70%] 2xl:w-[70%] mx-auto">
                    <div className="border border-[#D0D5DD] p-3 rounded">
                        <div className="flex -mx-10 ">
                            <div className="px-10 w-[45%]">
                                <div className="2xl:w-[90%] w-full">
                                    <div className="flex items-center mb-4">
                                        <label htmlFor="bname" className="text-f7 font-normal text-[#031624] min-w-[121px] inline-flex">Academic Year</label>
                                        <label htmlFor="bname" className="text-f7 font-semibold text-[#031624] min-w-[121px] inline-flex">{editData.academic_year.name}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="px-10 w-[55%]">
                                <div className="w-full">
                                    <div className="flex items-center mb-4">
                                        <div className="flex items-center w-[80%]">
                                            <label htmlFor="bname" className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Fee Term Name</label>
                                            <input
                                                disabled={!Edit}
                                                id="fee_term_name" 
                                                // onFocus={()=>setsubmitSelected(false)}
                                                placeholder='Enter Fee Term Name'
                                                onChange={(e)=>handleInput('fee_term_name',e.target.value)}
                                                maxLength={30}
                                                className={`${ submitSelected && state.fee_term_name.trim()===''?'redBorder':''} w-full inpt-fld  error_border shadow-s12 fee_term_editr ${!Edit?' bg-[#E6E8EA] shadow-s12':''}`}
                                                value={state.fee_term_name}
                                            />
                                        </div>
                                        <div className="w-[20%] pl-5">
                                            <div className="w-full flex justify-start">
                                                {!Edit && !isInactiveBranch && editData.status && <button onClick={()=>setEdit(true)} type="button" className="edit_btn_acadamic_year">
                                                    <div className='relative group'>
                                                        <img loading="lazy" decoding="async" src="/images/offcanvasEditDetails.svg" alt className="w-full self-center" />
                                                        <span class="absolute top-6 left-1/2 transform -translate-x-1/2 scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Edit</span>
                                                    </div>
                                                </button>}
                                                {Edit &&<><div className="relative group show_editable_acadamic_year mt-2">
                                                    <button onClick={() => handleSubmit()} type="button">
                                                        <img loading="lazy" decoding="async" src="/images/otp-tick.svg" alt="icon" className="w-5 h-5 onboardInstitution" />
                                                        <span class="absolute top-8 left-1/2 transform -translate-x-1/2 scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Update</span>
                                                    </button>
                                                </div><div className='relative group mt-2'>
                                                    <button type="button" className="ml-2" onClick={() => {
                                                        handleInput('fee_term_name', editData.fee_term_name)
                                                        setEdit(false)
                                                    } }>
                                                        <img loading="lazy" decoding="async" src="/images/file-remove.svg" alt="icon" className="w-5 h-5" />
                                                        <span class="absolute top-8 left-1/2 transform -translate-x-1/2 scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Cancel</span>

                                                    </button>
                                                </div></>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-4 w-[80%]">
                                        <label htmlFor="bname" className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">No. of Fee Terms</label>
                                        <label htmlFor="bname" className="text-f7 font-semibold text-[#031624] min-w-[130px] inline-flex">{editData.number_of_fee_terms}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="xl:w-[70%] 2xl:w-[65%] mx-auto mt-6 border border-[#E6E8EA]">
                    <div className="flex w-full items-center p-2 pb-1.5 border-b border-[#E6E8EA] formHeaderbg">
                        <div className="min-w-[100px] max-w-[100px]" />
                        <div className="flex items-center -mx-10 w-full">
                            <div className="w-1/3 px-10">
                                <div className="w-full">
                                    <p className="font-semibold text-f7 text-[#031624] class-name-error">Start Date</p>
                                </div>
                            </div>
                            <div className="w-1/3 px-10">
                                <div className="w-full">
                                    <p className="font-semibold text-f7 text-[#031624] class-name-error">End Date</p>
                                </div>
                            </div>
                            <div className="w-1/3 px-10">
                                <div className="w-full">
                                    <p className="font-semibold text-f7 text-[#031624] class-name-error">Due Date</p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    {/* start of term 1 section */}
                    {editData?.terms.map((term,i)=>(
                        <div className="flex w-full items-center p-2 pb-3.5 pt-3 border-b border-[#E6E8EA]" key={term.start_date}>
                            <div className="min-w-[100px] max-w-[100px] font-semibold">Term {i+1}</div>
                            <div className="flex items-center -mx-10 w-full">
                                <div className="w-1/3 px-10">
                                    <div className="relative w-full">
                                        {moment(term.start_date).format('MMM DD, YYYY')}
                                    </div>
                                </div>
                                <div className="w-1/3 px-10">
                                    <div className="relative w-full">
                                        {moment(term.end_date).format('MMM DD, YYYY')}
                                    </div>
                                </div>
                                <div className="w-1/3 px-10">
                                    <div className="relative w-full">
                                        {moment(term.due_date).format('MMM DD, YYYY')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {/* end of term 1 section */}
                    
                </div>
            </div>
        </div>

    )
}
